import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import Spinner from 'react-spinkit'
import { GetPost } from '../../../../firebase/firebase';
import * as Icon from 'react-bootstrap-icons';

export const BlogPostCard = (props) => {
    const id = props.id
    const [post, setPost] = useState('')
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (loading) {
            GetPost(id).then((data) => {
                setPost(data.data())

            })
            setLoading(false)
        }

    }, [loading])

    return (
        <>
        
            {loading ?
                <Container style={{ top: '0', position: 'absolute' }} fluid className='min-vh-100 d-flex flex-grow-1'>
                    <Row className="justify-content-center flex-grow-1">
                        <Col className='d-flex justify-content-center align-items-center'>
                            <Spinner className="d-flex flex-wrap align-items-center mx-0 px-0" name='ball-pulse-sync' />
                        </Col>
                    </Row>
                </Container>
                :
                <Container fluid className='pt-4'>
                    <Row className="justify-content-center">
                        <Col lg={6}>
                            <Card>
                                <Card.Header>
                                    {post.title}
                                </Card.Header>
                                <Row>
                                    <Col md={8} lg={8} xl={8} className='text-center mx-auto d-block'>
                                        <Card.Img
                                            variant='top'
                                            src={post.image}
                                            className='p-3'
                                            
                                        />
                                    </Col>
                                </Row>

                                <Card.Body>
                                    {post.text}
                                </Card.Body>
                                <Card.Footer>


                                    {post.likes} Likes


                                </Card.Footer>
                                <Card.Footer>
                                    by {post.creator} on {new Date(post.time).toDateString()}
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            }
        </>
    )
}
